module.exports = __webpack_public_path__ + "assets/img/index-company1.4bb8b1e1.jpg";